export { default } from './DemoAccount';


// WEBPACK FOOTER //
// ./app/javascript/src/pages/demo_account/index.jsx